import type { InferGetStaticPropsType } from 'next';
import { lazy, Suspense, useCallback, useMemo } from 'react';

import { getSignin } from 'services/idm';

import { apiErrorHandler } from '@login/helpers';
import { getLocaleStaticProps } from '@login/helpers/static-props';
import { useIdmPage } from '@login/hooks/use-idm-page';

const SigninForm = lazy(
	() => import('@login/patterns/signin-form/signin-form')
);
const FormBox = lazy(() => import('@login/components/form-box/form-box'));

export const getStaticProps = getLocaleStaticProps;

const SignIn = ({ locale }: InferGetStaticPropsType<typeof getStaticProps>) => {
	const onError = useCallback(
		(error: unknown) => apiErrorHandler(error, locale),
		[locale]
	);

	const {
		pageData: signinData,
		shouldDisplay,
		token,
	} = useIdmPage({
		queryKey: ['signin', locale],
		queryFn: () => getSignin(locale),
		onError,
	});

	const userUnderAge = useMemo(
		() =>
			signinData?.action === 'Display' &&
			signinData.flow.contentId === 'user-under-age',
		[signinData]
	);

	if (!shouldDisplay || !signinData) return null;

	return (
		<Suspense>
			<FormBox>
				<SigninForm
					placeholders={signinData.placeholders}
					token={token}
					userUnderAge={userUnderAge}
				/>
			</FormBox>
		</Suspense>
	);
};

export default SignIn;
